import { ErrorBox as EhrBox } from "@metriport/shared-internal";
import axios from "axios";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function getClientId(): string {
  return process.env.REACT_APP_PRACTICEFUSION_CLIENT_ID!; // eslint-disable-line @typescript-eslint/no-non-null-assertion
}
export function getRedirectUri(): string {
  return process.env.REACT_APP_PRACTICEFUSION_REDIRECT_URI!; // eslint-disable-line @typescript-eslint/no-non-null-assertion
}

// Clear all cookies before OAuth redirect to prevent WAF blocking
function clearAllCookies(): void {
  document.cookie.split(";").forEach(cookie => {
    const cookieName = cookie.split("=")[0]?.trim();
    if (!cookieName) return;
    // Clear cookies set with .metriport.com domain
    document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.metriport.com`;
    // Clear cookies set on current host only
    document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });
}

export default function LaunchPage() {
  const location = useLocation();
  const inputParams = new URLSearchParams(location.search);
  const iss = inputParams.get("iss");
  const launch = inputParams.get("launch");

  useEffect(() => {
    async function discoverAndRedirect() {
      const discoveryUrl = `${iss}/.well-known/smart-configuration`;
      const response = await axios.get(discoveryUrl);
      const config = response.data;
      const authorizationUrl = config.authorization_endpoint;
      const tokenUrl = config.token_endpoint;
      // PracticeFusion either not encoding state properly or intentionally strip {}!
      // Base64 encode to avoid URL encoding issues with curly braces
      const state = btoa(JSON.stringify({ tokenUrl }));
      const redirectParams = new URLSearchParams();
      redirectParams.append("response_type", "code");
      redirectParams.append(
        "scope",
        "launch openid patient:r_demographics_v2 fhirUser user/Patient.read"
      );
      redirectParams.append("client_id", getClientId());
      redirectParams.append("redirect_uri", getRedirectUri());
      redirectParams.append("aud", iss ?? "temp");
      redirectParams.append("state", state);
      redirectParams.append("launch", launch ?? "temp");
      const redirectUrl = `${authorizationUrl}?${redirectParams.toString()}`;
      clearAllCookies();
      window.location.replace(redirectUrl);
    }
    discoverAndRedirect();
  }, [iss, launch]);

  return <EhrBox>Launching...</EhrBox>;
}
